module.exports = __webpack_public_path__ + "img/0.d0e279a8.png";